import apiClient from '../client';
import $U from '../urls';

export const getCities = (country = 1) => {
  const params = { country, limit: 9999 };
  return apiClient.request('GET', $U.ADDRESS_CITY, params);
};

export const getTownships = city => {
  const params = { city, limit: 9999 };
  return apiClient.request('GET', $U.ADDRESS_TOWNSHIP, params);
};

export const getDistricts = township => {
  const params = { township, limit: 9999 };
  return apiClient.request('GET', $U.ADDRESS_DISTRICT, params);
};

export const setDefaultAddress = pk => {
  return apiClient.request('PATCH', `${$U.ADDRESS}${pk}/`, {
    primary: true,
  });
};

export const addAddress = form => {
  return apiClient.request('POST', $U.ADDRESS, form);
};

export const updateAddress = (pk, data) => {
  return apiClient.request('PATCH', `${$U.ADDRESS}${pk}/`, data);
};

export const removeAddress = pk => {
  return apiClient.request('DELETE', `${$U.ADDRESS}${pk}/`);
};

export const fetchAddresses = (page = 0) => {
  const params = {};

  if (page) {
    params.page = page;
  }

  return apiClient.request('GET', $U.ADDRESS_LIST, params);
};

export const fetchAddress = (pk) => {
  return apiClient.request('GET', `${$U.ADDRESS}${pk}`);
}
